import { BaseAuditLogEntry, ResourceType } from '../types/auditLogs.types';
import { EnrichmentMaps } from '../types/enrichment.types';

/**
 * Resolves an entry's author to a name using the `users` enrichment, for
 * resources whose entries carry only the author's id. The anonymous author,
 * standing in for the system, is never in the map and keeps no name.
 */
export function enrichAuthorAuditLogEntry<TResource extends ResourceType>(
  entry: BaseAuditLogEntry<TResource>,
  { users }: EnrichmentMaps,
): BaseAuditLogEntry<TResource> {
  const user = users[entry.author.id];
  if (!user?.name) return entry;
  return { ...entry, author: { ...entry.author, name: user.name } };
}
